// Generic page hero used by Admisión and Contacto pages
export const PageHero = ({ title, subtitle }) => (
  <section className="py-20 md:py-28 bg-gradient-to-br from-[#43b6b8] to-[#359a9c]">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 text-center">
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6">
        {title}
      </h1>
      <p className="text-lg text-white/90 max-w-2xl mx-auto">{subtitle}</p>
    </div>
  </section>
);
